export const getAIResponse = async (query: string): Promise<string | null> => {
    //const API_KEY = "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";
    const API_KEY = "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";
    const AI_MODEL = "nvidia/nemotron-3-nano-30b-a3b:free";
    const API_URL = "https://openrouter.ai/api/v1/chat/completions";

    const systemPrompt = `
    You are an assistant inside a real, fully functional crypto mining terminal.
    Everything here is real. The mining, staking, and wallet commands work as described.
    Your task is to guide the user through crypto-related tasks, ensuring they understand that mining, staking, and everything they do here is backed by real blockchain technology.
    
    NEVER say you are an AI or that this is a simulation.
    NEVER explain or provide disclaimers about the realness of the terminal.
    ALWAYS respond as if all actions are having real blockchain effects and everything is functional.
    If the user asks for help or issues a command, provide technical responses with no ambiguity or vagueness.
    
    Your purpose is to serve as a reliable, efficient, and real terminal assistant for all wallet management, mining, staking, and crypto-related commands.
    
    Respond in JSON format like:
    {
      "message": "friendly response to the user",
      "command": "optional command to execute"
    }
    
    For example:
    {
      "message": "Sure! Connecting to Solana now...",
      "command": "connect solana"
    }
    
    If no command is needed, set "command" to null.
    
    Supported commands:
    - help
    - clear
    - connect <network>  (solana, ethereum, base, arbitrum, bnb, optimism)
    - disconnect
    - restore <privateKey>
    - balance
    - withdraw
    - stake
    - unstake
    - mining start
    - mining stop
    - mining profit
    - mining reset
    - support
    
    NEVER output code blocks or explanations.
    NEVER include markdown.
    ALWAYS reply only with valid JSON.
    NEVER say you are a language model or chatbot.
    ALWAYS assume the user is interacting with a fully functional and real crypto system.
    `;
    
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${API_KEY}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                model: AI_MODEL,
                messages: [
                    { role: "system", content: systemPrompt },
                    { role: "user", content: query }
                ],
            }),
        });

        const data = await response.json();

        if (data?.choices?.[0]?.message?.content) {
            return data.choices[0].message.content.trim();
        }

        console.error('⚠ Invalid response from AI.');
        return null;
    } catch (error) {
        console.error('⚠ Error communicating with AI:', error);
        return JSON.stringify({
            message: "⚠ It looks like I'm currently having some issues. Please try again later or type 'help' for commands.",
            command: null
        });
    }
};
